import React, { Children, useContext, useEffect, useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { HeaderContent } from '../../app/components/sharedcomponents';
//import resourceData from './resources/ResourceData'
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { showProfile, showDeleteAccount, DialogState, lastRefreshUnreadMessageCountSelector, showAuthProfile } from "../../features/dialogSlice";
import { useSelector, useDispatch/*, shallowEqual*/ } from 'react-redux';
import Badge from '@mui/material/Badge';
import { useAuth } from "react-oidc-context";
//import { getUserAttributes } from '../features/userAttributesSlice'
import { ConfirmDeleteProfile } from '../iam/DeleteProfile';
import { setPublicPinClicked } from '../../features/dataProcessingSlice';

import { useAuthProfile } from "../../app/hooks"
//import { useMultiChatLogic, MultiChatSocket, MultiChatWindow } from "react-chat-engine-advanced";
//import { chatApi, useGetChatUserQuery, useGetMessageCountQuery } from '../../features/ChatSlice';
import { skipToken } from '@reduxjs/toolkit/query';
//import { useState, useEffect } from 'react';
import { profileApi } from '../../features/profilesSlice';
import { showCareCenters, showWarriors } from '../../features/filterSlice';
//import { RightSideUIContext } from '../../App';
import { cognitoAuthConfig, Condition, condition, coonditionContext } from '../..';
import { themePolygon } from '../../app/theme'
import { useTheme } from '@emotion/react';
import { Stack } from '@mui/material';
import { CUSTOM_METHOD, HOSTED_UI_REDIRECT } from '../../app/auth/utils';
import { useGetUnreadCountQuery } from "../../features/useChatSlice";
import { POLLING_INTERVAL_MS } from '../../features/chatService';
import { getUnreadMessagesAllConverstations } from '../messaging/ChatScopeUseChat';
import { LongPressGuard } from '../../app/components/LongPressGueard';
import { BRAND, BRAND_DARK, BRAND_DARKER } from '../healthwallet/healthWalletConstants';

const pages2show = [
    { name: 'Map', href: '/' },
    { name: "Conversations", href: "/Conversations" },
    { name: "Resources", href: "/Resources" },
    //{ name: "Blog", href: "https://www.polygonhealth.com/blog" },
    { name: "Health Wallet", href: "/HealthWallet" },
    { name: "Contact", href: "/Contact" },
] //...linkData.map((row: any) => ({ name: row.name, href: '' }))]

const settingsAuthenticated = [
    'Map', 'Conversations', 'Resources',
    'Health Wallet',
    //'Blog',
    'Contact',
];
const settingsUnAuthenticated = ['Login'];


// const RenderMenuTextBadge: (wrappedNode: React.ReactNode, badgeIt: string, showOnMenuItem?: boolean) => React.ReactNode = (wrappedNode, badgeIt, showOnMenuItem) =>
//     <React.Fragment>
//         {parseInt(badgeIt) > 0 ?
//             <Badge showZero={false} badgeContent={badgeIt} color="error" overlap="circular" sx={{
//                 '& .MuiBadge-badge': {
//                     top: showOnMenuItem ? -4 : 2, right: showOnMenuItem ? 2 : 8 // default is ~8; smaller = higher
//                 },
//             }}>
//                 {wrappedNode}
//             </Badge> :
//             <> {wrappedNode}</>
//         }
//     </React.Fragment>


const RenderMenuTextBadge: (wrappedNode: React.ReactNode, badgeIt: number | string | undefined | null, showOnMenuItem?: boolean) => React.ReactNode = (wrappedNode, badgeIt, showOnMenuItem) =>       
            <Badge  invisible={!badgeIt} showZero={false} badgeContent={badgeIt} color="error" overlap="circular" sx={{
                '& .MuiBadge-badge': {
                    top: showOnMenuItem ? -4 : 2, right: showOnMenuItem ? 2 : 8 // default is ~8; smaller = higher
                },
            }}>
                {wrappedNode}
            </Badge> 
    



export const NavBar1: React.FC = () => {
    const { profile, isLoading: isAuthProfileLoading, isProfileSuccess,/*isSuccess: isAuthProfileSuccess, isError: isAuthProfileError, error: authProfileError,*/  /*messagingReady,*/ authUser: user, error: errorAuthenticator, authUser, isAuthenticated, isLoading: isLoadingAuth, isSuccess: isAuthSuccess, authMethod, customAuth } = useAuthProfile()
    const loggedInId = (isProfileSuccess && isAuthenticated && profile.id) ? profile.id : skipToken
    const shouldFetch = isProfileSuccess && isAuthenticated;
    //const [badgeMessageCount, setBadgeMessageCount] = useState<string>('')
    //const { data: messageCount, isSuccess: isSuccessMessageCount } = useGetUnreadCountQuery(shouldFetch && loggedInId ? { profileId: profile.id } : skipToken, { pollingInterval: POLLING_INTERVAL_MS });

    const badgeMessageCount = useSelector(lastRefreshUnreadMessageCountSelector);

    const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
    const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
    const navigate = useNavigate()
    const [params, setSearchParams] = useSearchParams();
    const t = params.get("t");
    //   const userSignIn = params.get("userSignIn") === 'true'
    const noLoginPrompt = params.get("nlp") === 'true'
    //   const phooneNumberToLink = params.get("phone");
    //   const conversationId = params.get("conversationId");
    const dispatch = useDispatch();
    const auth = useAuth()

    const { condition, baseName } = React.useContext<Condition>(coonditionContext);
    const handleSignOut = async () => {
        try {
            dispatch(setPublicPinClicked(false))
            //dispatch(showCareCenters(false));
            //dispatch(showWarriors(false));           
            switch (authMethod) {
                case HOSTED_UI_REDIRECT:
                    auth.removeUser()
                    auth.signoutRedirect({
                        state: { baseName },
                        post_logout_redirect_uri: auth.settings?.post_logout_redirect_uri,
                        extraQueryParams: {
                            client_id: auth.settings?.client_id,//"7amp8un1r51k9p7qqj00jovh75",
                            redirect_uri: auth.settings?.post_logout_redirect_uri ?? false,//"http://localhost:4000/map/admin/out/",
                            logout_uri: auth.settings?.post_logout_redirect_uri ?? false,//"http://localhost:4000/map/admin/out/",
                            response_type: "code",
                            state_data: baseName
                        },
                    })
                    break
                case CUSTOM_METHOD:
                    customAuth.logout()
                    break
            }
        } catch (error) {
            // add error handling here
            console.log(error);
        }
    };

    const showDeleteAccountState = useSelector((state: any) => state.dialog.showDeleteAccount);
    // const userAttributesState = useSelector((state: any) => state.userattributes, (prev, next) => {
    //     if (!next.status.isSuccess && !next.status.isError) return true
    //     if (!prev.userAttributes) return false
    //     return prev.userAttributes.sub === next.userAttributes.sub
    // });

    async function handleDeleteAccount() {
        try {
            dispatch(showDeleteAccount(true))
            //setErrorVisible('hidden');
        } catch (error) {
            // add error handling here
            console.log(error);
        }
    };
    const location = useLocation();
    const isHealthWallet = location.pathname.toLowerCase().includes('healthwallet');

    async function handleProfile() {
        try {
            dispatch(showProfile({ isForced: true }))
            // const currentPath = location.pathname;
            if (location.pathname > "/") {
                navigate("/")
            }
            setAnchorElUser(null);
        } catch (error) {
            // add error handling here
            console.log(error);
        }
    };

    //async Handle

    const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
        //if (isAuthProfileSuccess) {
        setAnchorElNav(event.currentTarget);
        //}
    };
    const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        //if (isAuthProfileSuccess) {
        setAnchorElUser(event.currentTarget);
        //}
    };

    const handleNavMenu: (menuOption: string) => void = (menuOption) => {
        //if (isAuthProfileSuccess) {
        switch (menuOption) {
            case 'Map':
                navigate("/")
                break;
            default:
                const route = menuOption.replace(/\s/g, '-')
                navigate(`/${route}`)
                break;
                //  }
                setAnchorElNav(null);
        }
    }
    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleUserMenu = (menuOption: string) => {
        switch (menuOption) {
            case 'Map':
                navigate("/")
                break;
            case 'Conversations':
                navigate("/Conversations")
                break;
            case 'Resources':
                navigate("/Resources")
                break;
            case 'Blog':
                window.open("https://www.polygonhealth.com/blog", '_blank');
                break;
            case 'Contact':
                navigate("/Contact")
                break;
            case 'Delete Account':
                handleDeleteAccount()
                break;
            case 'Sign Out':
                handleSignOut()
                break;
            case 'Profile':
                handleProfile()
                break;
            case 'Health Wallet':
                navigate("/healthwallet")
                break;
            //setAnchorElNav(null);
        }
        setAnchorElUser(null);
    };
    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const theme = useTheme();

    //{authStatus === 'unauthenticated' && (<Button sx={{ backgroundColor: '#656EFF', color: 'white', fontSize: '12px' }} href="/map/Sign-In/">Sign in</Button>)}
    //const { /*user,*/ authStatus } = useAuthenticator((context) => [context.user])
    const pages = (/*isAuthProfileSuccess ||*/ true) ? pages2show.filter((link, index) => link.name !== 'Blog' || condition === 'Multiple Myeloma') : []

    const settings = ((user || isAuthenticated) && !isLoadingAuth && !errorAuthenticator) ? (isAuthenticated ? settingsAuthenticated : settingsUnAuthenticated) : []//configuring status
    return (
        <AppBar position="fixed" elevation={0} sx={{
            bgcolor: 'rgba(244, 240, 255, 0.55)',
            backdropFilter: 'blur(24px)',
            WebkitBackdropFilter: 'blur(24px)',
            borderBottom: '1px solid rgba(164, 142, 233, 0.18)',
            boxShadow: '0 1px 12px rgba(0, 0, 0, 0.04)',
            zIndex: 1100,
        }} >
            <LongPressGuard onLongPress={() => dispatch(showAuthProfile(true))} >
                <Container maxWidth={false} >
                    <Toolbar disableGutters>
                        <Box sx={{ flexGrow: 0, display: { xs: 'flex', md: 'none' } }}>
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleOpenNavMenu}
                                color="inherit"
                            >
                                <MenuIcon style={{ color: 'black' }} />
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorElNav}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                                open={Boolean(anchorElNav)}
                                onClose={handleCloseNavMenu}
                                onClick={handleCloseNavMenu}
                                slotProps={{
                                    paper: {
                                        sx: {
                                            backgroundColor: 'rgba(244, 240, 255, 0.75)',
                                            backdropFilter: 'blur(24px)',
                                            WebkitBackdropFilter: 'blur(24px)',
                                            border: '1px solid rgba(164, 142, 233, 0.18)',
                                            borderRadius: 3,
                                            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
                                        },
                                    },
                                }}
                                sx={{
                                    display: { xs: 'block', md: 'none' },
                                }}
                            >
                                {pages.filter((link, index) => link.name !== 'Blog' || condition === 'Multiple Myeloma').map((link, index) => (
                                    <MenuItem key={index} onClick={() => handleUserMenu(link.name)} sx={{ '&:hover': { backgroundColor: 'rgba(164, 142, 233, 0.1)' } }}>
                                        {RenderMenuTextBadge(<Typography textAlign="center">{link.name} </Typography>, link.name === "Conversations" ? badgeMessageCount : '', true)}
                                    </MenuItem>
                                ))}
                            </Menu>
                        </Box>

                        <HeaderContent />

                        <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                            {pages.map((link, index) => (
                                <React.Fragment key={index ?? 0}>{RenderMenuTextBadge(
                                    <Button
                                        key={index}
                                        onClick={() => handleUserMenu(link.name)}
                                        sx={{
                                            color: (location.pathname.replace('map', '').replace('/', '') === link.name.replace('Map', '')) ? '#6b21a8' : '#555555',
                                            fontWeight: 'bold',
                                            borderRadius: 0,
                                            position: 'relative',
                                            transition: 'color 0.2s ease',
                                            '&::after': {
                                                content: '""',
                                                position: 'absolute',
                                                bottom: 6,
                                                left: '20%',
                                                width: (location.pathname.replace('map', '').replace('/', '') === link.name.replace('Map', '')) ? '60%' : '0%',
                                                height: 3,
                                                borderRadius: 2,
                                                backgroundColor: '#6b21a8',
                                                transition: 'width 0.25s ease',
                                            },
                                            '&:hover::after': {
                                                width: '60%',
                                            },
                                            '&:hover': {
                                                color: '#6b21a8',
                                            },
                                        }}
                                    >
                                        {link.name}
                                    </Button>, link.name === "Conversations" ? badgeMessageCount : '')}</React.Fragment>
                            ))}
                        </Box>

                        <Box sx={{ flexGrow: 0 }}>
                            {(/*isAuthSuccess &&*/ !isAuthenticated) && <>
                                <Stack direction={'row'} spacing={1} justifyContent="flex-end" alignItems="center">

                                    <Badge invisible={!errorAuthenticator} badgeContent={"≠"} color="warning" overlap="circular" anchorOrigin={{ vertical: 'bottom' }}   >
                                        <Button id="navbar_signin" sx={{ backgroundColor: isHealthWallet ? 'white' : '#656EFF', color: isHealthWallet ? BRAND_DARKER : 'white', fontSize: '12px', borderRadius: 8 }}
                                            onClick={() => {
                                                if (t && noLoginPrompt) {
                                                    const singinParams = new URLSearchParams({ ...t ? { t } : {} });
                                                    navigate(`/SignInToMap?${singinParams.toString()}`)
                                                } else {
                                                    navigate("/Signin")
                                                }
                                            }} >Sign in</Button>
                                    </Badge>


                                </Stack>
                            </>}
                            {(isAuthSuccess && isAuthenticated) && (<>
                                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                    {RenderMenuTextBadge(<Avatar sx={{ bgcolor: '#6b21a8' }} />, badgeMessageCount)}
                                </IconButton>
                                <Menu
                                    sx={{ mt: '45px' }}
                                    slotProps={{
                                        paper: {
                                            sx: {
                                                backgroundColor: 'rgba(244, 240, 255, 0.75)',
                                                backdropFilter: 'blur(24px)',
                                                WebkitBackdropFilter: 'blur(24px)',
                                                border: '1px solid rgba(164, 142, 233, 0.18)',
                                                borderRadius: 3,
                                                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
                                            },
                                        },
                                    }}
                                    id="menu-appbar"
                                    anchorEl={anchorElUser}
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    keepMounted
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    open={Boolean(anchorElUser)}
                                    onClose={handleCloseUserMenu}
                                    onClick={handleCloseNavMenu}
                                >
                                    {settings.map((setting, index) => (
                                        (setting === 'Conversations')
                                            ?
                                            <MenuItem key={index} onClick={() => handleUserMenu(setting)} sx={{ display: { xs: 'flex', sm: 'flex', md: 'none' } }}>
                                                {RenderMenuTextBadge(<Typography textAlign="center">{setting}</Typography>, badgeMessageCount)}
                                            </MenuItem>
                                            :
                                            <MenuItem key={index} onClick={() => handleUserMenu(setting)} sx={{ display: { xs: 'flex', sm: 'flex', md: 'none' } }}>
                                                <Typography textAlign="center">{setting}</Typography>
                                            </MenuItem>
                                    ))}
                                    <MenuItem key={'delete'} onClick={() => handleUserMenu('Sign Out')} >
                                        <Typography textAlign="center">{'Sign Out'}</Typography>
                                    </MenuItem>
                                    <MenuItem key={'signout'} onClick={() => handleUserMenu('Delete Account')} >
                                        <Typography textAlign="center">{'Delete Account'}</Typography>
                                    </MenuItem>
                                </Menu>
                            </>)}
                        </Box>
                    </Toolbar>

                </Container>
            </LongPressGuard>
        </AppBar >
    );
}
//{showDeleteAccountState && <ConfirmDeleteProfile handleSignOut={handleSignOut} />}
//export default ChatsPageLoader;